import * as React from "react";
import Link from "../components/link";
import { FormattedMessage } from "react-intl";

const Meta = ({ destination, bar }) => {
  return (
    <div className={`meta${bar ? " meta-bar" : ""}`}>
      <p className="meta-date">{destination.dateRange}</p>
      <Link className="meta-link" href={`/destinations/${destination.slug}`}>
        <FormattedMessage
          id="discoverDestination"
          defaultMessage={"Découvrir cette destination"}
        />
      </Link>
    </div>
  );
};

export default Meta;
